import styled from 'styled-components';

export const Container = styled.div`
  .material-icons {
    font-size: 16px;
  }
`;
